import isApiError from "@insite/client-framework/Common/isApiError";
import { ServiceResult, get, patch } from "@insite/client-framework/Services/ApiService";
import {
    AccountBillToCollectionModel,
    CustomAccountBillToModel,
    GetAccountBillToCollectionApiParameter,
    PatchAccountBillToCollectionApiParameter,
    GetUnassignedBillTosApiParameters,
} from "@insite/client-framework/Types/ApiModels";

const accountsUrl = "api/v2/accounts";

const assignBillTosUrl = "api/v2/billtos";

export function getAccountBillToCollection(parameter: GetAccountBillToCollectionApiParameter) {
    return get<AccountBillToCollectionModel>(`${accountsUrl}/${parameter.accountId}/billtos`, parameter.sortBy);
}

export function saveEditedUserBillTosCollection(parameter: PatchAccountBillToCollectionApiParameter) {
        return patch<any>(`${accountsUrl}/${parameter.accountId}/billtos`, parameter.collection);
}

export function getUnassignedBillTosCollection(parameter: GetUnassignedBillTosApiParameters) {
    return get<AccountBillToCollectionModel>(`${assignBillTosUrl}`, parameter.queryParams);
}
